<template>
  <v-row dense>
    <v-col cols="12">
      <reference-field
        combobox
        v-model="product.name"
        item-text="nameWithPrice"
        @onselect="onSelect"
        reference="item"
        :rules="rules['name']"
        :filter="clientFilter"
        label="Название"
        autofocus
      />
    </v-col>
    <v-col cols="6" md="3">
      <currency-field
        v-model="product.price"
        :rules="rules['price']"
        label="Цена за единицу"
      />
    </v-col>
    <v-col cols="6" md="3">
      <quantity-field
        v-model="product.quantity"
        :rules="rules['quantity']"
        label="Количество"
      />
    </v-col>
    <v-col cols="12" md="6">
      <v-select
        :items="taxTypes"
        item-text="name"
        item-value="id"
        clearable
        v-model="product.taxType"
        :rules="rules['taxType']"
        label="Ставка НДС"
      />
    </v-col>
    <v-col cols="12" md="6">
      <v-select
        :items="productTypes"
        item-text="name"
        item-value="id"
        clearable
        v-model="product.productType"
        label="Тип предмета расчета"
      />
    </v-col>
    <v-col cols="12" md="6">
      <v-select
        :items="paymentMethods"
        item-text="name"
        item-value="id"
        clearable
        v-model="product.paymentMethod"
        placeholder="Полный расчет"
        label="Способ расчета"
      />
    </v-col>
    <v-col cols="12" md="6">
      <v-text-field
        v-model="product.productId"
        label="Внутренний идентификатор товара (при наличии)"
      />
    </v-col>
    <AgentFields
      v-model="agent"
      :disabled="false"
      :rules="rules"
      rules-prefix="agent."
    />
    <v-col cols="12" md="12">
      <v-text-field
        v-model="productCode"
        label="Маркировка (ввод сканером)"
        :error="productCodeError"
      />
    </v-col>
  </v-row>
</template>
<script>
import { TaxTypes, ProductTypes, PaymentMethods } from "@/datastore/enums";
import AgentFields from "@/components/ui/forms/AgentFields";
export default {
  name: "ProductFields",
  components: { AgentFields },
  props: {
    value: Object,
    rules: {
      type: Object,
      default: () => ({})
    },
    forceTaxType: Number,
    clientId: String
  },
  data() {
    return {
      product: this.value,
      agent: this.value.agent || {},
      productCode: this.value.productCode
        ? atob(this.value.productCode)
        : undefined,
      taxTypes: TaxTypes,
      productTypes: ProductTypes,
      paymentMethods: PaymentMethods,
      productCodeError: false
    };
  },
  computed: {
    clientFilter() {
      return this.clientId ? { clientId: this.clientId } : {};
    }
  },
  methods: {
    onSelect(v) {
      v || (v = "");
      if (typeof v === "string") {
        this.product.name = v;
        return;
      }
      this.product.name = v.product.name;
      this.product.price = v.product.price;
      this.product.quantity = v.product.quantity;
      this.product.taxType = v.product.taxType || this.forceTaxType;
      this.product.productType = v.product.productType;
      this.product.paymentMethod = v.product.paymentMethod;
    }
  },
  watch: {
    "agent.agentType": function(v) {
      if (!v) {
        this.value.agent = undefined;
      } else {
        this.value.agent = this.agent;
      }
    },
    productCode: function(v) {
      this.productCodeError = false;
      if (!v) {
        this.value.productCode = undefined;
      } else {
        try {
          this.value.productCode = btoa(v);
        } catch (e) {
          this.productCodeError = true;
        }
      }
    }
  }
};
</script>
